import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Terms = () => {
  const { t, i18n } = useTranslation('legal');
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <html lang={i18n.language} />
        <title>{t('terms.meta.title')}</title>
        <meta name="description" content={t('terms.meta.description')} />
        <link rel="canonical" href="https://www.cetasol.com/term_conditions" />
        <meta property="og:title" content={t('terms.meta.title')} />
        <meta property="og:description" content={t('terms.meta.description')} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.cetasol.com/term_conditions" />
        <meta property="og:image" content="https://www.cetasol.com/og-image.jpg" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={t('terms.meta.title')} />
        <meta name="twitter:description" content={t('terms.meta.description')} />
        <meta name="twitter:image" content="https://www.cetasol.com/og-image.jpg" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org", "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.cetasol.com/" },
            { "@type": "ListItem", "position": 2, "name": t('terms.heading'), "item": "https://www.cetasol.com/term_conditions" }
          ]
        })}</script>
      </Helmet>
      <Header />
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-6">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="max-w-3xl prose prose-invert">
            <h1 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-6">{t('terms.heading')}</h1>
            <p className="text-sm text-muted-foreground mb-10">{t('terms.lastUpdated')}</p>
            <div className="space-y-8 text-muted-foreground text-sm leading-relaxed">
              {[1,2,3,4,5,6,7].map(n => (
                <section key={n}>
                  <h2 className="font-display text-lg font-semibold text-foreground mb-3">{t(`terms.s${n}Title`)}</h2>
                  <p>{t(`terms.s${n}Text`)}{n === 7 && <> <a href="mailto:legal@cetasol.com" className="text-primary hover:underline">legal@cetasol.com</a>.</>}</p>
                </section>
              ))}
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
